import baseEChartData from '@/theme/default/components/charts/echarts/mixins/common/baseEChartData'

export default {
  mixins: [baseEChartData]
}
